import React from 'react'
import { ListGroup, Card, Button } from 'react-bootstrap'
import {
  IoIosArrowForward as ArrowForwardIcon,
  IoMdMenu as MenuIcon,
} from 'react-icons/io'
import { NavLink } from 'react-router-dom'
import { observer } from 'mobx-react'
import { reaction } from 'mobx'
import { customerContainer, loyaltyContainer, storeContainer } from 'src/models'
import {
  i18nTranslate,
  application,
  isB2B2C,
  convertToBoolean,
  enableAccountSettings,
  getLiveEventStatus,
} from 'src/utils'
import {
  accountTypeTranslation,
  myAccountMenuDeps,
  isFetchAllPromoCodeEnabled,
} from 'src/deps'
import { myAccountSideBar } from './myAccountSideBar'
import { pageNames } from 'src/routes/pathParams'
import { signInwithRedirect } from 'src/utils/signInUtils'
import { APPConfig } from 'config/appConfig'
import { SkipLink } from 'src/views/components'
import {
  isLoyEnableInProf,
  isAllowedRewardTypeForOptIn,
} from 'src/views/pages/MyAccount/MyAccountProfile/LoyaltyForm/fixture'
import { MicroFrontendLoader } from 'src/views/components/MicroFrontends/MicroFrontendLoader'
@observer
class MyAccountMenu extends React.Component {
  async componentDidMount() {
    if (customerContainer.isProfileCallOver) {
      this.myaccountInitialFunctionality()
    } else {
      const reactions = reaction(
        () => customerContainer.isProfileCallOver,
        (isProfileCallOverNewValue, reaction) => {
          this.myaccountInitialFunctionality()
          reaction.dispose()
        }
      )
    }
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    if (window.innerWidth <= 768) {
      myAccountMenuDeps.isMenuVisible = false
    } else {
      myAccountMenuDeps.isMenuVisible = true
    }
  }

  myaccountInitialFunctionality = async () => {
    const isRegisterUser = customerContainer.isRegisterUser

    if (!isRegisterUser) {
      APPConfig.getAppConfig().signInType === 'okta'
        ? signInwithRedirect(false)
        : this.props.history.push(`${pageNames.signIn}`)
    } else {
      await this.getLoyaltyPoints()
    }
  }
  getLoyaltyPoints = async () => {
    await loyaltyContainer.getLoyaltyPoints(true)
  }
  handleSkipLink = () => {
    window.scrollTo(0, 0)
  }

  renderMenuItem(item) {
    const {
      label,
      link,
      iconClassName = '',
      icon: Icon,
      dataTestid = 'qa-account-options',
    } = item

    return (
      <>
        <NavLink
          to={link}
          isActive={(match, location) => {
            if (match) return true
            if (
              link === pageNames.myaccountsubscriptions &&
              location.pathname === pageNames.manageSubscription
            ) {
              return true
            }
            return false
          }}
          onClick={() => {
            if (application.isMobile) {
              myAccountMenuDeps.isMenuVisible = false
            }
          }}
          key={label}
          data-testid={dataTestid}
          className="pt-3 pb-3 d-flex text-body align-items-center text-decoration-none pl-3 pr-3">
          {Icon && (
            <Icon
              className={`account-menu-icon ${iconClassName}`}
              aria-label={i18nTranslate('myAccount.accountIcon', `${label}`)}
              aria-hidden="true"
            />
          )}
          <div className="account-menu-item-text ml-2" style={{ flex: 1 }}>
            {label}
          </div>
          <ArrowForwardIcon className="account-menu-link-arrow" />
        </NavLink>
        {link == this.props?.currentPage && (
          <SkipLink
            handleClick={this.handleSkipLink}
            className="skip-myaccount-link text-primary bg-white"
            skipTo="#my-account-details-wrapper">
            <a href="#">
              {i18nTranslate('skipNav', 'Skip to navigation', {
                nameSpace: 'ssr-resource',
              }) +
                ' ' +
                label +
                ' ' +
                i18nTranslate('content', 'content')}
            </a>
          </SkipLink>
        )}
      </>
    )
  }

  renderMenuList() {
    const sideBarResponse = myAccountSideBar()
    return sideBarResponse.map(item => this.renderMenuItem(item))
  }
  renderNewSideMenu() {
    const wrapperClass =
      enableAccountSettings() || this.props.useAccountProfileSideMenu ? 'mfe-bg-color' : ''
    const remoteConfig = {
      appName: 'account-profile',
      component: 'ProfileSideMenu',
    }
    const params = {
      customerData: customerContainer?.profileResponse,
      isFetchAllPromoCodeEnabled: isFetchAllPromoCodeEnabled(),
      enableLiveEvent: convertToBoolean(getLiveEventStatus()),
    }
    return (
      <aside className={`account-menu-wrapper  mb-0 ${wrapperClass}`}>
        <MicroFrontendLoader remoteConfig={remoteConfig} params={params} />
      </aside>
    )
  }

  render() {
    const { firstName, lastName, accounts } = customerContainer?.profileResponse
    const totalloyaltyPoints =
      loyaltyContainer.loyaltyPointsResponse?.userMath?.LOYALTY?.total
        ?.openToRedeem || 0
    const hideLoyaltyAlways =
      APPConfig?.getAppConfig()?.hideLoyaltyAlways === 'true'
    const hideLoyaltyForUS =
      APPConfig?.getAppConfig()?.hideLoyaltyForUS === 'true'
    const storeIdBasedOnCountry =
      storeContainer?.storeIDValue?.toLowerCase() || ''
    const isUS = storeIdBasedOnCountry === 'us'
    const isToHideLoyaltyForUS = hideLoyaltyForUS && isUS

    return (
      <>
        {enableAccountSettings() || this.props.useAccountProfileSideMenu ? (
          this.renderNewSideMenu()
        ) : (
          <aside className={'account-menu-wrapper  mb-0 shadow'}>
            <div className="d-flex menu-row pt-4">
              <div className="menu-icon p-3 my-auto">
                <Button
                  className="myaccount-sidemenu text-bottom"
                  variant="dark"
                  onClick={myAccountMenuDeps.toggleFilter}
                  aria-label="toggle side menu"
                  data-testid="myaccount-sidemenu">
                  <MenuIcon />
                </Button>
              </div>
              <Card
                className="card-wrapper flex-grow-1"
                style={{ border: 0, borderRadius: 0 }}>
                <Card.Body className="text-white bg-dark account-name-wrapper p-3">
                  <Card.Subtitle
                    data-testid="qa-account-welcome-text"
                    className="mb-0 font-weight-light">
                    {i18nTranslate('myaccount.welcome', 'Welcome!')}
                  </Card.Subtitle>
                  <Card.Title
                    data-testid="qa-account-welcome-name"
                    className="font-weight-bold">
                    {firstName} {lastName}
                  </Card.Title>
                  <Card.Text
                    className="font-weight-light account-id"
                    data-testid="qa-account-welcome-id">
                    {accounts?.referenceAttribute}
                  </Card.Text>
                  {!hideLoyaltyAlways &&
                    !isToHideLoyaltyForUS &&
                    isB2B2C() &&
                    isLoyEnableInProf() &&
                    isAllowedRewardTypeForOptIn() && (
                      <Card.Text className="mb-0 font-weight-light">
                        <b>
                          {'$'}
                          {totalloyaltyPoints?.toFixed(2) || totalloyaltyPoints}
                        </b>{' '}
                        {i18nTranslate(
                          'loyalty.totalEarnedPoints',
                          'Total Points Available'
                        )}
                      </Card.Text>
                    )}
                  <Card.Text
                    className="mt-3 font-normal"
                    data-testid="qa-account-type">
                    {/* {i18nTranslate('accounts.type', accounts && accounts.type)} */}
                    {accountTypeTranslation(accounts?.type) || ''}
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
            {myAccountMenuDeps.isMenuVisible && (
              <div className="d-block">
                <ListGroup role="button">{this.renderMenuList()}</ListGroup>
              </div>
            )}
          </aside>
        )}
      </>
    )
  }
}

export default MyAccountMenu
export { MyAccountMenu }
